<template>
  <div
    :id="modalId"
    :class="classList"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            title="Close"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h2 class="modal-title">
            <i v-if="icon" :class="`fas ${icon}`" />
            {{ modalTitle }}
          </h2>
        </div>
        <div class="modal-body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      modalId: { type: String, required: false, default: '' },
      icon: { type: String, required: false, default: '' },
      modalTitle: { type: String, required: true },
      smallModal: { type: Boolean, required: false, default: false },
      effect: { type: String, required: false, default: 'fade' },
    },
    computed: {
      classList: function() {
        const list = ['tdesk-modal', 'modal'];

        if (this.effect) { list.push(this.effect); }
        if (this.smallModal) { list.push('tdesk-small-modal'); }

        return list;
      },
    },
  };
</script>
